import * as React from "react";

import "./NewCallModal.css";

import { connect } from "react-redux";

import { Modal, ModalBody, ModalHeader } from "reactstrap";

import { IProfile, IProfileUpdate } from "../api/APIClient";
import { RootState } from "../types";
import { updateProfile as updateProfileThunk } from "src/thunks";

interface IProps {
  profile?: IProfile;
  isOpen: boolean;
  toggleOpen: () => void;
  updateProfile: (update: IProfileUpdate) => any;
}

export class ShowUserModal extends React.Component<IProps> {
  public render() {
    const { profile, isOpen, toggleOpen } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={toggleOpen}>
        <ModalHeader toggle={toggleOpen}>
          {profile ? profile.username : null}
        </ModalHeader>
        <ModalBody>{this.renderBody()}</ModalBody>
      </Modal>
    );
  }

  private renderBody = () => {
    const { profile } = this.props;
    if (!profile) {
      return null;
    }

    const {
      id,
      name,
      username,
      timeZone,
      sendNewsletter,
      disabled,
      deleted,
      version,
      createdAt,
    } = profile;

    return (
      <table>
        <tbody>
          <tr>
            <td>
              <b>ID</b>
            </td>{" "}
            <td>{id}</td>
          </tr>
          <tr>
            <td>
              <b>Name</b>
            </td>{" "}
            <td>{name || "(blank)"}</td>
          </tr>
          <tr>
            <td>
              <b>Username</b>
            </td>{" "}
            <td>{username}</td>
          </tr>
          <tr>
            <td>
              <b>Time Zone</b>
            </td>{" "}
            <td>{timeZone}</td>
          </tr>
          <tr>
            <td>
              <b>Send Newsletter</b>
            </td>{" "}
            <td>{sendNewsletter ? "yes" : "no"}</td>
          </tr>
          <tr>
            <td>
              <b>Disabled</b>
            </td>{" "}
            <td>
              <input
                type="checkbox"
                onChange={this.onChangeDisabled}
                checked={disabled}
              />
            </td>
          </tr>
          <tr>
            <td>
              <b>Deleted</b>
            </td>{" "}
            <td>{deleted ? "yes" : "no"}</td>
          </tr>
          <tr>
            <td>
              <b>Version</b>
            </td>{" "}
            <td>{version}</td>
          </tr>
          <tr>
            <td>
              <b>Created At</b>
            </td>{" "}
            <td>{createdAt}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  private onChangeDisabled = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { profile, updateProfile } = this.props;
    const { checked } = e.currentTarget;

    if (!profile) {
      return;
    }
    updateProfile({ id: profile.id, disabled: checked });
  };
}

export const ShowUserContainer = connect(
  ({ profiles }: RootState) => ({
    profile: profiles.selectedID
      ? profiles.data.find(p => p.id === profiles.selectedID)
      : undefined,
  }),
  dispatch => ({
    updateProfile: (update: IProfileUpdate) =>
      dispatch<any>(updateProfileThunk(update)),
  })
)(ShowUserModal);

export default ShowUserContainer;



// WEBPACK FOOTER //
// ./src/pages/ShowUserModal.tsx